import React from "react";
import {
    CREATE_FEATURES_BASE_ROUTE,
    CREATE_FEATURES_SUB_ROUTES,
    EDIT_CONFIGURATION_ROUTES
} from "../util/RouteConstants";
import {Redirect,Route} from "react-router-dom";
import {injectIntl} from "react-intl"
import {NavigationRoutes}  from "../util/TabLayout"
import Column from "@amzn/meridian/column";


const UpdateConfiguration = () => {
    return (
        <div className="App">
            <Column >
                <Route exact path={`/${CREATE_FEATURES_BASE_ROUTE}`} >
                    <Redirect to={`/${CREATE_FEATURES_BASE_ROUTE}/${CREATE_FEATURES_SUB_ROUTES.CREATE_CONFIG}`}/>
                </Route>
                <NavigationRoutes routes={EDIT_CONFIGURATION_ROUTES}/>
            </Column>
        </div>
    )
}

export default injectIntl(UpdateConfiguration)


// WEBPACK FOOTER //
// ./src/components/update-config/UpdateConfiguration.js